import { IIntegrationUploadHistoryResponse } from '@kcftech/prometheustypescriptapiclient';
import { DataSourceTable } from 'components/data_source_table/DataSourceTable';
import { TableColumn } from 'components/data_table/types';
import { DateRelativeToNow } from 'components/date_time/DateRelativeToNow';
import { IntegrationUploadHistoryPagedDataSource } from 'custom_hooks/data_hooks/data_source/integrationUploadHistoryDataSource';
import { useMemo } from 'react';
import { getId } from 'utils/data';

export type IntegrationMappingHistoryTabProps = Readonly<{
    dataSource: IntegrationUploadHistoryPagedDataSource;
}>;

export function IntegrationMappingHistoryTab({
    dataSource,
}: IntegrationMappingHistoryTabProps) {
    const columns = useMemo<TableColumn<IIntegrationUploadHistoryResponse>[]>(
        () => [
            {
                header: () => 'Uploaded File',
                id: 'FileName',
                primary: true,
                value: ({ rowData }) => rowData.FileName,
            },
            {
                header: () => 'Date',
                id: 'Created',
                value: ({ rowData }) => <DateRelativeToNow date={rowData.Created} />,
            },
            {
                header: () => 'User',
                id: 'CreatedBy',
                value: ({ rowData }) => (
                    <>
                        {rowData.CreatedBy.UserFirstName} {rowData.CreatedBy.UserLastName}
                    </>
                ),
            },
            {
                header: () => 'Status',
                id: 'Status',
                value: ({ rowData }) => rowData.Status,
            },
        ],
        []
    );

    return (
        <DataSourceTable
            dataSource={dataSource}
            noResultMessage="No previous uploads available"
            columns={columns}
            rowKey={getId}
        />
    );
}
